// Shared wiring for the Firebase Cloud Functions emulator.
//
// The emulator is only used for local development and must be explicitly
// enabled (REACT_APP_USE_FUNCTIONS_EMULATOR=true and REACT_APP_ENV=local).
// Precondition: the emulator process must already be running on host:port.
//
// Consumed by FirebaseAuth (connectFunctionsEmulator), utils/axios, and the
// login-v2 identity redirect so the enable-check and host/port fallbacks stay
// consistent across all three call sites.

// True when the local Functions emulator should be used.
export const isFunctionsEmulatorEnabled = () =>
  process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true' &&
  process.env.REACT_APP_ENV === 'local'

// Host/port the local emulator listens on.
// Host falls back to 'localhost', port falls back to 5001 if unset/non-numeric.
export const getEmulatorHostPort = () => ({
  host: process.env.REACT_APP_FUNCTIONS_EMULATOR_HOST || 'localhost',
  port: parseInt(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT, 10) || 5001,
})
